import get from 'lodash/get';

export const getGiftCardSerialNumberToRemove = state =>
  get(state, 'order.giftCardToRemove.serialNumber', null);

export const getGiftCardIdToRemove = state => get(state, 'order.giftCardToRemove.id', null);
